<template>
  <div class="page-class page-user-list">
    <div v-if="socketDownload.active" class="download-progress-modal">
      <div class="progress-card">
        <div v-if="!socketDownload.showProgress" class="loader-spinner"></div>
        <p class="progress-kicker">Report download</p>
        <h3 class="status-title">{{ socketDownload.status }}</h3>
        <template v-if="socketDownload.showProgress">
          <div class="progress-percent">{{ socketDownload.percent }}<span>%</span></div>
          <div
            class="progress-track"
            role="progressbar"
            :aria-valuenow="socketDownload.percent"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div class="progress-fill" :style="{ width: socketDownload.percent + '%' }"></div>
          </div>
          <p class="progress-count">
            {{ formatCompactCount(socketDownload.processed) }}
            <span>of</span>
            {{ formatCompactCount(socketDownload.total) }}
            <span>orders</span>
          </p>
        </template>
        <p v-else class="sub-text">Please wait while we prepare your CSV file. This might take a moment.</p>
      </div>
    </div>
    <h1 class="page-title">{{ title }}</h1>
    <table-box-order
      :columns="columnsToShow"
      :rows="order"
      :baseUrl="baseUrl"
      :loading="loading"
      :showAdd="true"
      :showOtherFilter="ifAdmin()"
      :showForthReport="false"
      :showFifthReport="isSRLAdmin()"
      :showSixthReport="ifAdmin()"
      :showChallanWiseReport="isSRLAdmin()"
      :disableSixthReport="isVoidReportDisabledByDateRange"
      :showSeventhReport="isSRLAdminOrSsm()"
      :showEighthReport="isSRLAdminOrSsm()"
      :showDownload="ifCallCenterExecutive() && !isLimitedAdmin()"
      :showUpload="false"
      :showToolbar="true"
      :sourceOptions="this.generateSourceOptions"
      :showPagination="true"
      :isOfflineOrder="true"
      :showDownloadMessageReport="isExecutiveAndNbl() && !isLimitedAdmin()"
      :showDownloadAptReport="isExecutiveAndNbl() && !isLimitedAdmin()"
      :showDownloadProductReport="true"
      :pagination="pagination"
      :filterOptions="filterOptions"
      :isTabsRequired="handleTabsRequired"
      :searchItems="searchItems"
      addText="Create new order"
      forthReportText="Rider Report"
      sixthReportText="Void Report"
      challanWiseReportText="Challan Wise Report"
      fifthReportText="Rider Agency Report"
      seventhReportText="Challan Payment Report"
      eighthReportText="Rider Challan Article Report"
      downloadText="Download Orders List"
      uploadText="Upload Orders List"
      emptyText="No order found. Please add new order."
      downloadMessageReportText="Download Message Report"
      downloadAptText="Download Apt-Abt-Adt Report"
      downloadProductReportText="Download Product Report"
      @add="onAdd"
      @edit="onEdit"
      @acknowledge="onAcknowledge"
      @delete="onDelete"
      @download="onExportCSV"
      @download-message-report="onExportMessageCSV"
      @show-upload="onShowUpload"
      @apt-report="onAptReport"
      @download-product-report="onExportProductCSV"
      @fetch-offline="onFetchOffline"
      @fourth-report="onRiderReport"
      @fifth-report="onRiderAgency"
      @sixth-report="onSocketReport"
      @challan-wise-report="onChallanWiseReport"
      @seventh-report="onChallanPaymentReport"
      @eighth-report="onRiderChallanArticleReport"
    >
      <template v-slot:emailAddressFormatted="slotProps">
        <span class="span-text span-block">
          {{ slotProps.row.email }}
        </span>
        <template v-if="slotProps.row.confirmedAtFormatted">
          <span class="text-success span-help-text" :title="slotProps.row.confirmedAt">
            ({{ slotProps.row.confirmedAtFormatted }})
          </span>
        </template>
        <template v-if="slotProps.row.confirmedAtFormatted === null">
          <span class="text-warning span-help-text"> (Not confirmed) </span>
        </template>
      </template>
      <template v-slot:lastLoginAtFormatted="slotProps">
        <template v-if="slotProps.row.lastLoginAtFormatted">
          <span class="text-success">{{ slotProps.row.lastLoginAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.lastLoginAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
      <template v-slot:blockedAtFormatted="slotProps">
        <template v-if="slotProps.row.blockedAtFormatted">
          <span class="text-success">{{ slotProps.row.blockedAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.blockedAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
    </table-box-order>
    <div> </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import router from '@/router'; //eslint-disable-line
import _ from 'lodash';
import io from 'socket.io-client';
import TableBoxOrder from '../../components/TableBoxOrder.vue';
import User from '../../model/user';
import orderService from '../../services/orderService';

export default {
  name: 'OrderList',
  components: {
    TableBoxOrder
  },
  metaInfo() {
    return {
      title: 'Orders',
      meta: [
        {
          name: 'description',
          content: `Manage orders`
        }
      ]
    };
  },
  mounted() {
    this.listStoreDetail({ router });
    if (_.isEmpty(this.$route.query)) {
      this.list({
        query: {
          ...this.$route.query,
          startdate: moment().format('YYYY-MM-DD'),
          enddate: moment().format('YYYY-MM-DD')
        }
      });
    } else {
      this.list({ query: this.$route.query });
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.list({ query: to.query });
    next();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
  data() {
    return {
      title: 'Orders',
      searchItems: ['Customer Mobile', 'Name', 'Address', 'Store Id'],
      isOnlineStoreSelected: false,
      storeOptions: [],
      selectedStoreId: '',
      selectedStoreObj: {},
      isSingleStore: false,
      pinCode: '',
      isOnlineData: false,
      isProductReportExport: false,
      filterOptions: [
        { value: null, text: 'Select Filter' },
        { value: 'Source-SINGLE_FORM_ENTRY', text: 'Source-SINGLE_FORM_ENTRY' },
        { value: 'Source-CALL_CENTER_ENTRY', text: 'Source-CALL_CENTER_ENTRY' },
        { value: 'Source-BULK_CSV_UPLOAD', text: 'Source-BULK_CSV_UPLOAD' },
        // { value: 'Source-OUTBOUND_APP_ENTRY', text: 'Source-OUTBOUND_APP_ENTRY' },
        { value: 'Source-B2B_ENTRY', text: 'Source-B2B_ENTRY' },
        { value: 'Source-ORDERING_APP_ENTRY', text: 'Source-ORDERING_APP_ENTRY' },
        { value: 'Source-DIRECT_POS_ENTRY', text: 'Source-DIRECT_POS_ENTRY' },
        { value: 'Acknowledged-True', text: 'Acknowledged-True' },
        { value: 'Acknowledged-False', text: 'Acknowledged-False' },
        { value: 'Delivered-True', text: 'Delivered-True' },
        { value: 'Delivered-False', text: 'Delivered-False' },
        { value: 'B2bOrderType=Spencer_Agent', text: 'B2bOrderType-Spencer_Agent' },
        { value: 'B2bOrderType=Vendor_Self', text: 'B2bOrderType-Vendor_Self' }
      ],
      socket: null,
      csvChunks: [],
      socketDownload: {
        active: false,
        status: '',
        showProgress: false,
        percent: 0,
        processed: 0,
        total: 0
      }
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('auth', {
      authUser: 'user'
    }),

    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('order', [
      'loading',
      'baseUrl',
      'orders',
      'pagination',
      'downloadOrdersList',
      'downloadMessageRecordList',
      'downloadAptReportList',
      'errorMessage',
      'ecomOrderList',
      'riderReportData',
      'riderAgency'
    ]),
    ...mapState('store', ['storeList', 'storeListDetail']),
    generateSourceOptions() {
      const options = [{ value: null, text: 'Select Current Cycle' }];
      const today = moment();
      for (let i = 2; i < 36; i += 1) {
        const date = moment(today).subtract(i, 'months');
        const value = `${date.format('YYYY-MM')}-orders`;
        const text = `${date.format('MMM YYYY')}`;
        options.push({ value, text });
      }

      return options;
    },
    handleTabsRequired() {
      const storeIds = ['H049'];
      const logic = storeIds.some(store => this.user.storeids.includes(store));
      if (logic) {
        return true;
      }
      return false;
    },
    isVoidReportDisabledByDateRange() {
      const { startdate, enddate } = this.$route.query;
      if (!startdate || !enddate) {
        return false;
      }

      const start = moment(startdate, 'YYYY-MM-DD', true);
      const end = moment(enddate, 'YYYY-MM-DD', true);
      if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) {
        return false;
      }

      // Disable when selected range exceeds one calendar month.
      return end.isAfter(start.clone().add(1, 'month'), 'day');
    },
    order() {
      return this.orders.map(i => {
        let status = '';
        if (i.actualDeliveredTime) {
          status = `Order Delivered: ${i.actualDeliveredTime}`;
        } else if (i.packagedTime) {
          status = `Order Packaged: ${i.packagedTime}`;
        } else if (i.posPingTime) {
          status = `Bill Generated:  ${i.posPingTime}`;
        } else if (i.acknowledgedTime) {
          status = `Acknowledged Time:  ${i.acknowledgedTime}`;
        } else {
          status = `Order Created: ${i.createdAt}`;
        }

        return {
          ...i,
          status
        };
      });
    },
    columnsToShow() {
      const newUser = this.authUser.roles.map(role => role.name);
      const admin = newUser.filter(role => role.includes('ADMIN'));
      if (admin.length > 0 && !this.isLimitedAdmin()) {
        return [
          {
            type: 'row_num',
            headerText: '#',
            class: { 'text-center': true },
            textKey: 'id',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Customer Mobile',
            class: { 'text-center': true },
            textKey: 'customerMobile',
            width: '7%'
          },
          {
            type: 'string',
            headerText: 'Store Id',
            class: { 'text-center': true },
            textKey: 'storeid',
            width: '4%'
          },
          {
            type: 'string',
            headerText: 'Order Date Id',
            class: { 'text-center': true },
            textKey: 'orderDateId',
            width: '6%'
          },
          {
            type: 'string',
            headerText: 'B2B Order Type',
            class: { 'text-center': true },
            textKey: 'b2bOrderType',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Name',
            class: { 'text-center': true },
            textKey: 'name',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Products',
            class: { 'text-center': true },
            textKey: 'products',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Address',
            class: { 'text-center': true },
            textKey: 'address',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Description',
            class: { 'text-center': true },
            textKey: 'description',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Payment Method',
            class: { 'text-center': true },
            htmlKey: 'modeOfPayment',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Order Status',
            class: { 'text-center': true },
            htmlKey: 'status',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Acknowledged ',
            class: { 'text-center': true },
            textKey: 'isAcknowledged',
            width: '7%'
          },
          {
            type: 'string',
            headerText: 'Delivered',
            class: { 'text-center': true },
            textKey: 'isDelivered',
            width: '8%'
          },
          {
            type: 'string',
            headerText: 'Source',
            class: { 'text-center': true },
            textKey: 'source',
            width: '8%'
          },

          {
            type: 'string',
            headerText: 'Delivery code',
            class: { 'text-center': true },
            textKey: 'deliveryCode',
            width: '8%'
          },
          {
            type: 'functions',
            headerText: 'Functions',
            class: { 'text-center': true },
            width: '12%',
            functions: {
              edit: true,
              delete: true,
              ack: false
            }
          }
        ];
      }
      if (this.isLimitedAdmin()) {
        return [
          {
            type: 'row_num',
            headerText: '#',
            class: { 'text-center': true },
            textKey: 'id',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Company Name',
            class: { 'text-center': true },
            textKey: 'employeeCompany',
            width: '8%'
          },
          {
            type: 'string',
            headerText: 'Rider Name',
            class: { 'text-center': true },
            textKey: 'employeeName',
            width: '10%'
          },
          {
            type: 'string',
            headerText: 'Store Id',
            class: { 'text-center': true },
            textKey: 'storeid',
            width: '6%'
          },
          {
            type: 'string',
            headerText: 'Order Date Id',
            class: { 'text-center': true },
            textKey: 'orderDateId',
            width: '8%'
          },
          {
            type: 'string',
            headerText: 'B2B Order Type',
            class: { 'text-center': true },
            textKey: 'b2bOrderType',
            width: '8%'
          },
          {
            type: 'string',
            headerText: 'Products',
            class: { 'text-center': true },
            textKey: 'products',
            width: '12%'
          },
          {
            type: 'string',
            headerText: 'Payment Method',
            class: { 'text-center': true },
            htmlKey: 'modeOfPayment',
            width: '6%'
          },
          {
            type: 'string',
            headerText: 'Order Status',
            class: { 'text-center': true },
            htmlKey: 'status',
            width: '12%'
          },
          {
            type: 'string',
            headerText: 'Acknowledged ',
            class: { 'text-center': true },
            textKey: 'isAcknowledged',
            width: '8%'
          },
          {
            type: 'string',
            headerText: 'Delivered',
            class: { 'text-center': true },
            textKey: 'isDelivered',
            width: '5%'
          },
          {
            type: 'string',
            headerText: 'Source',
            class: { 'text-center': true },
            textKey: 'source',
            width: '12%'
          } // {
          //   type: 'functions',
          //   headerText: 'Functions',
          //   class: { 'text-center': true },
          //   width: '13%',
          //   functions: {
          //     edit: true,
          //     delete: true,
          //     ack: false
          //   }
          // }
        ];
      }
      return [
        {
          type: 'row_num',
          headerText: '#',
          class: { 'text-center': true },
          textKey: 'id',
          width: '5%'
        },
        {
          type: 'string',
          headerText: 'Customer Mobile',
          class: { 'text-center': true },
          textKey: 'customerMobile',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Store Id',
          class: { 'text-center': true },
          textKey: 'storeid',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Order Date Id',
          class: { 'text-center': true },
          textKey: 'orderDateId',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'B2B Order Type',
          class: { 'text-center': true },
          textKey: 'b2bOrderType',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Name',
          class: { 'text-center': true },
          textKey: 'name',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Products',
          class: { 'text-center': true },
          textKey: 'products',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Address',
          class: { 'text-center': true },
          textKey: 'address',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Description',
          class: { 'text-center': true },
          textKey: 'description',
          width: '7%'
        },
        {
          type: 'string',
          headerText: 'Payment Method',
          class: { 'text-center': true },
          htmlKey: 'modeOfPayment',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Order Status',
          class: { 'text-center': true },
          htmlKey: 'status',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Acknowledged ',
          class: { 'text-center': true },
          textKey: 'isAcknowledged',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Delivered',
          class: { 'text-center': true },
          textKey: 'isDelivered',
          width: '5%'
        },
        {
          type: 'string',
          headerText: 'Source',
          class: { 'text-center': true },
          textKey: 'source',
          width: '13%'
        }
        // {
        //   type: 'functions',
        //   headerText: 'Functions',
        //   class: { 'text-center': true },
        //   width: '10%',
        //   functions: {
        //     edit: true,
        //     delete: true,
        //     ack: false
        //   }
        // }
      ];
    },
    handleDisabled() {
      return this.selectedStoreId === '' || (this.isOnlineStoreSelected && this.pinCode.length < 6);
    }
  },
  watch: {
    async riderAgency(newValue) {
      const filteredValues = newValue.filter(order => {
        const hasBillNumber = !!order.billNumber;
        const storeId = (order.storeid || '').toUpperCase();
        const isStoreIdInvalid = storeId.startsWith('N') || ['D413', 'S117'].includes(storeId);

        return hasBillNumber && !isStoreIdInvalid;
      });

      if (filteredValues.length > 0) {
        let csv = '';

        // Check if user is limited admin
        if (this.isLimitedAdmin()) {
          // Generate date-wise report for limited admin (uses today as default if no date selected)
          csv = await this.generateDateWiseAgencyReport();
        } else {
          // Generate regular report for other users
          csv = this.generateRegularAgencyReport(filteredValues);
        }

        // Download CSV
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'Rider-Agency-Report.csv';
        anchor.click();
      }
    },
    async riderReportData(newValue) {
      if (newValue.length > 0) {
        let csv = '';

        // Check if user is limited admin
        if (this.isLimitedAdmin()) {
          // Generate date-wise report for limited admin (uses today as default if no date selected)
          csv = await this.generateDateWiseRiderReport();
        } else {
          // Generate regular report for other users
          csv = this.generateRegularRiderReport(newValue);
        }

        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'Riders_Report.csv';
        anchor.click();
      }
    },
    downloadOrdersList(newValue) {
      if (newValue.length) {
        // Check if this is a product report export
        if (this.isProductReportExport) {
          this.isProductReportExport = false;
          this.generateProductReportCSV(newValue);
          return;
        }

        let csv;
        if (this.user.company === 'SRL') {
          csv =
            'Order Id,Order Date Id,Customer Name,Customer Address,Source,Customer Mobile,Created On,Updated On,Description,Store Id,Acknowledged,Delivered,Products,Order Created Time,order Acknowledged Time,Order Packaged Time ,Bill Generated Time,Order Delivered Time,Order Mode,outboundType, Pincode,Bill Number,Bill Value,Delivery Acknowledged,Delivery Acknowledged Time,Delivery Acknowledged By,On Role,Picker Employee Id,Picker Mobile Number,Picker Name,Picker Agency ,Bill No found Status,Sales Report Status\n';
          newValue.forEach(row => {
            csv += `"${row.orderId}","\t${row.orderDateId || ''}","${row.name
              ?.replaceAll(',', '_')
              .replaceAll('"', '_')}","${row.address?.replaceAll(',', '_').replaceAll('"', '_')}","${row.source}","${
              row.customerMobile
            }","${row.dateCreated}","${row.dateUpdated}","${row.description
              ?.replaceAll(',', '_')
              .replaceAll('"', '_')}","${row.storeid}","${row.isAcknowledged}","${
              row.isDelivered
            }","${row.products?.replaceAll(',', '_').replaceAll('"', '_')}","${row.createdAt}","${
              row.acknowledgedTime
            }","${row.packagedTime}","${row.posPingTime}","${row.actualDeliveredTime}","${row.orderMode}","${
              row.outboundType || ''
            }","${row.pinCode}","${row.billNumber}","${Number(row.posItems || 0).toFixed(2)}","${
              row.isDeliveryAcknowledged
            }","${row.deliveryAcknowledgedTime}","${row.deliveryAcknowledgedBy}","${row.ifOffRole}","${
              row.employeeCode
            }","${row.employeeMobile}","${row.employeeName}","${row.employeeCompany}","${row.finalStatus}","${
              row.matchedWithSales
            }"\n`;
          });
        } else {
          csv =
            'Order Id,Order Date Id,Customer Name,Customer Address,Source,Customer Mobile,Created On,Updated On,Description,Store Id,Acknowledged,Delivered,Products,Order Created Time,order Acknowledged Time,Order Packaged Time ,Bill Generated Time,Order Delivered Time,Order Mode,outboundType, Pincode,Bill Number,Bill Value\n';
          newValue.forEach(row => {
            csv += `"${row.orderId}","\t${row.orderDateId || ''}","${row.name}","${row.address}","${row.source}","${
              row.customerMobile
            }","${row.dateCreatedForCSV(row.dateUpdated)}","${row.description}","${row.storeid}","${
              row.isAcknowledged
            }","${row.isDelivered}","${row.products}","${this.formatDateForCSV(row.createdAt)}","${
              row.acknowledgedTime
            }","${row.packagedTime}","${row.posPingTime}","${row.actualDeliveredTime}","${row.orderMode}","${
              row.outboundType || ''
            }","${row.pinCode}","${row.billNumber}","${Number(row.posItems || 0).toFixed(2)}"\n`;
          });
        }

        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'Orders.csv';
        anchor.click();
      }
    },
    downloadMessageRecordList(newValue) {
      if (newValue.length) {
        let csv = 'Row Number,Mobile,Medium,Type,Delivered,Store Id,Ref Id,Created At\n';
        newValue.forEach(row => {
          Object.values(row).forEach(val => {
            csv += `"${val}"`;
            csv += ',';
          });
          csv += '\n';
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'MessageLogs.csv';
        anchor.click();
      }
    },
    downloadAptReportList(newValue) {
      if (newValue.length) {
        let csv = '';
        csv += `,,Date: ${this.$route.query.startdate} to ${this.$route.query.enddate}\n`;
        csv += 'Region,App entry,Total orders,Total Delivered,Avg APT,ABT ,ADT ,App use %, DC use %\n';
        const regions = [
          ...new Set(
            newValue
              .map(row => row.storeRegion)
              .filter(region => region !== '' && region !== undefined && region !== null)
          )
        ];
        let indiaAppEntry = [];
        let indiaTotalOrder = [];
        let indiaTotalDelivered = [];
        let indiaAppUse = [];
        let indiaDcUse = [];
        regions.forEach(region => {
          const regionData = newValue.filter(row => row.storeRegion === region);
          const appEntry = regionData.reduce((acc, row) => acc + row.orderAppEntry, 0);
          const totalOrders = regionData.reduce((acc, row) => acc + row.totalOrders, 0);
          const totalIsDelivered = regionData.reduce((acc, row) => acc + row.isDelivered, 0);

          const totalAverageApt = this.totalAverageTimeConverter(
            regionData.reduce((acc, row) => acc + row.apt, 0),
            regionData.length
          );
          const totalAverageAbt = this.totalAverageTimeConverter(
            regionData.reduce((acc, row) => acc + row.abt, 0),
            regionData.length
          );
          const totalAverageAdt = this.totalAverageTimeConverter(
            regionData.reduce((acc, row) => acc + row.adt, 0),
            regionData.length
          );

          const avgDcUse = ((totalIsDelivered / totalOrders) * 100).toFixed(2);
          const avgAppUse = ((appEntry / totalOrders) * 100).toFixed(2);
          indiaAppEntry.push(appEntry);
          indiaTotalOrder.push(totalOrders);
          indiaTotalDelivered.push(totalIsDelivered);
          indiaAppUse.push(avgAppUse);
          indiaDcUse.push(avgDcUse);
          csv += `${region},${appEntry},${totalOrders},${totalIsDelivered},${totalAverageApt},${totalAverageAbt},${totalAverageAdt},${avgAppUse},${avgDcUse}\n`;
        });

        //  +++++++++++++++++++++++++++++++ India Calculation +++++++++++++++++++++++++++++++++++++++++++++++++++++++
        indiaAppEntry = indiaAppEntry.reduce((acc, curr) => acc + Number(curr), 0);
        indiaTotalOrder = indiaTotalOrder.reduce((acc, curr) => acc + Number(curr), 0);
        indiaTotalDelivered = indiaTotalDelivered.reduce((acc, curr) => acc + Number(curr), 0);
        indiaAppUse = ((indiaAppEntry / indiaTotalOrder) * 100).toFixed(2);
        indiaDcUse = ((indiaTotalDelivered / indiaTotalOrder) * 100).toFixed(2);
        // +++++++++++++++++++++++++++++++++ India store-wise +++++++++++++++++++++++
        const regionLength = newValue.filter(
          row => row.storeRegion !== null && row.apt !== null && row.abt !== null && row.adt !== null
        ).length;
        const indiaTotalAptSecondsByStore = regions.reduce((acc, region) => {
          const regionData = newValue.filter(row => row.storeRegion === region && row.apt !== null);
          return acc + regionData.reduce((acc, row) => acc + row.apt, 0);
        }, 0);
        const indiaTotalAbtSecondsByStore = regions.reduce((acc, region) => {
          const regionData = newValue.filter(row => row.storeRegion === region && row.abt !== null);
          return acc + regionData.reduce((acc, row) => acc + row.abt, 0);
        }, 0);
        const indiaTotalAverageAdtByStore = regions.reduce((acc, region) => {
          const regionData = newValue.filter(row => row.storeRegion === region && row.adt !== null);
          return acc + regionData.reduce((acc, row) => acc + row.adt, 0);
        }, 0);
        const indiaApt = this.totalAverageTimeConverter(indiaTotalAptSecondsByStore, regionLength);
        const indiaAbt = this.totalAverageTimeConverter(indiaTotalAbtSecondsByStore, regionLength);
        const indiaAdt = this.totalAverageTimeConverter(indiaTotalAverageAdtByStore, regionLength);
        csv += `India,${indiaAppEntry},${indiaTotalOrder},${indiaTotalDelivered},${indiaApt},${indiaAbt},${indiaAdt},${indiaAppUse},${indiaDcUse}`;
        csv += '\n\n';

        csv += ',ASM Wise Report\n';
        csv += `Region,ASM Name,App entry,total orders,total delivered,Avg APT, Avg Abt,Avg Adt,App use %, DC use %\n`;

        regions.forEach(region => {
          const regionData = newValue.filter(row => row.storeRegion === region);
          const asmList = [...new Set(regionData.map(row => row.asm))]; // Get unique ASM names within the region
          asmList.forEach(asm => {
            const asmData = regionData.filter(row => row.asm === asm);
            const appEntry = asmData.reduce((acc, row) => acc + row.orderAppEntry, 0);
            const totalOrders = asmData.reduce((acc, row) => acc + row.totalOrders, 0);
            const totalIsDelivered = asmData.reduce((acc, row) => acc + row.isDelivered, 0);
            const totalAbtSeconds = asmData.reduce((acc, row) => acc + row.abt, 0);
            const totalAdtSeconds = asmData.reduce((acc, row) => acc + row.adt, 0);
            const totalAverageApt = this.totalAverageTimeConverter(
              asmData.reduce((acc, row) => acc + row.apt, 0),
              asmData.length
            );
            const totalAverageAbt = this.totalAverageTimeConverter(totalAbtSeconds, asmData.length);
            const totalAverageAdt = this.totalAverageTimeConverter(totalAdtSeconds, asmData.length);
            const avgAppUse = ((appEntry / totalOrders) * 100).toFixed(2);
            const avgDcUse = ((totalIsDelivered / totalOrders) * 100).toFixed(2);
            csv += `${region},${
              asm || '-'
            },${appEntry},${totalOrders},${totalIsDelivered},${totalAverageApt},${totalAverageAbt},${totalAverageAdt},${avgAppUse},${avgDcUse}\n`;
          });
        });
        // ***************---- Tl wise ------**********************

        csv += '\n\n';
        csv += ',Tl Wise Report\n';
        csv += `Region,Tl Name,App entry,total orders,total delivered,Avg APT, Avg Abt,Avg Adt,App use %, DC use %\n`;

        regions.forEach(region => {
          const regionData = newValue.filter(row => row.storeRegion === region);
          const tlList = [...new Set(regionData.map(row => row.tl))]; // Get unique Tl names within the region
          tlList.forEach(tl => {
            const tlData = regionData.filter(row => row.tl === tl);
            const appEntry = tlData.reduce((acc, row) => acc + row.orderAppEntry, 0);
            const totalOrders = tlData.reduce((acc, row) => acc + row.totalOrders, 0);
            const totalIsDelivered = tlData.reduce((acc, row) => acc + row.isDelivered, 0);
            const totalAbtSeconds = tlData.reduce((acc, row) => acc + row.abt, 0);
            const totalAdtSeconds = tlData.reduce((acc, row) => acc + row.adt, 0);
            const totalAverageApt = this.totalAverageTimeConverter(
              tlData.reduce((acc, row) => acc + row.apt, 0),
              tlData.length
            );
            const totalAverageAbt = this.totalAverageTimeConverter(totalAbtSeconds, tlData.length);
            const totalAverageAdt = this.totalAverageTimeConverter(totalAdtSeconds, tlData.length);
            const avgAppUse = ((appEntry / totalOrders) * 100).toFixed(2);
            const avgDcUse = ((totalIsDelivered / totalOrders) * 100).toFixed(2);
            csv += `${region},${
              tl || '-'
            },${appEntry},${totalOrders},${totalIsDelivered},${totalAverageApt},${totalAverageAbt},${totalAverageAdt},${avgAppUse},${avgDcUse}\n`;
          });
        });
        // =======================================================================================================================
        // csv += 'Asm Wise\n';
        // csv += 'ASM,App entry,total orders,total delivered,Avg APT, Avg Abt,Avg Adt,App use %, DC use %\n';
        // const asmList = [...new Set(newValue.map(row => row.asm))];

        // asmList.forEach(asm => {
        //   const asmData = newValue.filter(row => row.asm === asm);
        //   const appEntry = asmData.reduce((acc, row) => acc + row.orderAppEntry, 0);
        //   const totalOrders = asmData.reduce((acc, row) => acc + row.totalOrders, 0);
        //   const totalIsDelivered = asmData.reduce((acc, row) => acc + row.isDelivered, 0);
        //   const totalAbtSeconds = asmData.reduce((acc, row) => acc + row.abt, 0);
        //   const totalAdtSeconds = asmData.reduce((acc, row) => acc + row.adt, 0);
        //   const totalAverageApt = this.totalAverageTimeConverter(
        //     asmData.reduce((acc, row) => acc + row.apt, 0),
        //     asmData.length
        //   );
        //   const totalAverageAbt = this.totalAverageTimeConverter(totalAbtSeconds, asmData.length);
        //   const totalAverageAdt = this.totalAverageTimeConverter(totalAdtSeconds, asmData.length);
        //   const avgAppUse = (asmData.reduce((acc, row) => acc + row.appUasgePercentage, 0) / asmData.length).toFixed(2);
        //   const avgDcUse = (asmData.reduce((acc, row) => acc + row.dcUsagePercentage, 0) / asmData.length).toFixed(2);
        //   csv += `${asm},${appEntry},${totalOrders},${totalIsDelivered},${totalAverageApt},${totalAverageAbt},${totalAverageAdt},${avgAppUse},${avgDcUse}\n`;
        // });

        // ========================================================================
        csv += '\n\n';
        csv +=
          'Store id,Store Name,Cluster,Region,Format,APT,ABT,ADT,Order App Entry,Total Orders,Is Delivered,App use %,Dc use %,ASM\n';
        newValue.forEach(row => {
          Object.values(row).forEach((val, index) => {
            if (index !== 5 && index !== 6 && index !== 7 && index !== 11 && index !== 12) {
              csv += `"${val}"`;
              csv += ',';
            } else if (index === 11 || index === 12) {
              csv += `"${val.toFixed(1)}"`;
              csv += ',';
            } else {
              csv += `"${this.milliSecondsToHours(val)}"`;
              csv += ',';
            }
          });
          csv += '\n';
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'APT-ABT-ADT Report.csv';
        anchor.click();
      }
    }
  },
  methods: {
    ...mapActions('order', [
      'list',
      'deleteOne',
      'upload',
      'sendAcknowledgement',
      'download',
      'downloadMessageRecord',
      'downloadAptReport',
      'getStoreAvailability',
      'setStorePinCode',
      'ecommOrderList',
      'riderReport',
      'getDetailReport'
    ]),
    ...mapActions('store', ['listStore', 'listStoreDetail']),
    formatDateForCSV(dateValue) {
      if (dateValue === null || dateValue === undefined || dateValue === '') {
        return '';
      }
      const dateStr = String(dateValue).trim();
      if (!dateStr || dateStr === 'null' || dateStr === 'undefined' || dateStr === 'Invalid Date') {
        return '';
      }
      if (typeof moment === 'undefined') {
        console.error('moment is not defined');
        return '';
      }

      let date = null;

      if (typeof dateValue === 'number' || (!Number.isNaN(Number(dateValue)) && !Number.isNaN(parseFloat(dateValue)))) {
        date = moment(Number(dateValue));
        if (date.isValid()) {
          return `\t${date.format('DD-MM-YYYY hh:mm A')}`;
        }
      }
      date = moment(dateValue);
      if (date.isValid()) {
        return `\t${date.format('DD-MM-YYYY hh:mm A')}`;
      }
      date = moment(dateStr);
      if (date.isValid()) {
        return `\t${date.format('DD-MM-YYYY hh:mm A')}`;
      }
      const commonFormats = [
        'DD-MM-YYYY hh:mm:ss A',
        'DD-M-YYYY hh:mm:ss A',
        'D-MM-YYYY hh:mm:ss A',
        'D-M-YYYY hh:mm:ss A',
        'DD-MM-YYYY h:mm:ss A',
        'DD-MM-YYYY hh:mm A',
        'DD-M-YYYY hh:mm A',
        'D-MM-YYYY hh:mm A',
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
        'YYYY-MM-DDTHH:mm:ssZ',
        'MM/DD/YYYY HH:mm:ss',
        'DD/MM/YYYY HH:mm:ss'
      ];

      const matchedFormat = commonFormats.find(format => {
        date = moment(dateStr, format, true); // strict parsing
        return date.isValid();
      });
      if (matchedFormat) {
        return `\t${date.format('DD-MM-YYYY hh:mm A')}`;
      }
      date = moment(dateStr, [
        'DD-MM-YYYY hh:mm:ss A',
        'DD-M-YYYY hh:mm:ss A',
        'D-MM-YYYY hh:mm:ss A',
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD'
      ]);
      if (date.isValid()) {
        return `\t${date.format('DD-MM-YYYY hh:mm A')}`;
      }

      return '';
    },
    formatCompactCount(value) {
      const count = Math.abs(Number(value) || 0);
      const units = [
        { limit: 10000000, suffix: 'Cr' },
        { limit: 100000, suffix: 'L' },
        { limit: 1000, suffix: 'K' }
      ];
      const unit = units.find(item => count >= item.limit);
      if (!unit) {
        return String(count);
      }
      const scaled = count / unit.limit;
      const digits = scaled >= 100 ? 0 : 1;
      const text = scaled.toFixed(digits).replace(/\.0$/, '');
      return `${text}${unit.suffix}`;
    },
    attachCsvProgress(socket) {
      socket.on('csv-progress-init', data => {
        const total = Number(data.totalRows) || 0;
        this.socketDownload.total = total;
        this.socketDownload.processed = 0;
        this.socketDownload.percent = 0;
        this.socketDownload.showProgress = total > 0;
        this.socketDownload.status = 'Preparing report';
      });
      socket.on('csv-progress', data => {
        const total = Number(data.totalRows) || 0;
        const processed = Number(data.processed) || 0;
        let percent = Number(data.percent);
        if (!Number.isFinite(percent)) {
          percent = total ? Math.min(100, Math.round((processed / total) * 100)) : 0;
        }
        this.socketDownload.total = total;
        this.socketDownload.processed = processed;
        this.socketDownload.percent = percent;
        this.socketDownload.showProgress = total > 0;
        this.socketDownload.status = 'Writing orders';
      });
    },
    onSocketReport() {
      this.socketDownload = {
        active: true,
        status: 'Connecting to server...',
        showProgress: false,
        percent: 0,
        processed: 0,
        total: 0
      };
      this.csvChunks = [];

      const token = localStorage.getItem('token');
      const storeId = new Date().getTime();
      const mobileNumber = this.authUser?.mobile || '9999999999';
      const startDate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const endDate = this.$route.query.enddate || moment().format('YYYY-MM-DD');

      try {
        const url =
          process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://spencer-apiv1.attabot.in';

        this.socket = io(url, { auth: { token } });

        this.socket.on('connect', () => {
          this.socketDownload.status = 'Generating report data...';
          this.socket.emit('join_room', { storeId, mobileNumber });
        });

        this.socket.on('room_joined', () => {
          this.triggerReportAPI(startDate, endDate, mobileNumber, storeId);
        });

        this.socket.on('csv-chunk', data => {
          this.csvChunks.push(data.chunk);
          this.socketDownload.status = 'Receiving data chunks...';
        });

        this.socket.on('csv-complete', () => {
          this.socketDownload.status = 'Finalizing file...';

          const blob = new Blob(this.csvChunks, { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Order_Details_${moment().format('YYYY-MM-DD')}.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          this.socket.emit('leave_room', { storeId, mobileNumber });
          this.socket.disconnect();

          setTimeout(() => {
            this.socketDownload.active = false;
          }, 1500);
        });

        this.socket.on('csv-error', () => {
          this.socketDownload.status = 'Error generating report.';
          setTimeout(() => {
            this.socketDownload.active = false;
          }, 3000);
        });
      } catch (error) {
        this.socketDownload.active = false;
      }
    },

    onChallanWiseReport() {
      const startdate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const enddate = this.$route.query.enddate || moment().format('YYYY-MM-DD');
      this.socketDownload = {
        active: true,
        status: 'Connecting to server...',
        showProgress: false,
        percent: 0,
        processed: 0,
        total: 0
      };
      this.csvChunks = [];

      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }

      const token = localStorage.getItem('token');
      const storeId = String(new Date().getTime());
      const mobileNumber = this.authUser?.mobile || '9999999999';
      const query = {
        startdate,
        enddate,
        storeId,
        mobileNumber
      };
      ['filter', 'search', 'searchkey', 'db'].forEach(key => {
        if (this.$route.query[key]) {
          query[key] = this.$route.query[key];
        }
      });

      const finishWithError = message => {
        this.socketDownload.status = message || 'Error generating report.';
        if (this.socket) {
          this.socket.emit('leave_room', { storeId, mobileNumber });
          this.socket.disconnect();
          this.socket = null;
        }
        setTimeout(() => {
          this.socketDownload.active = false;
        }, 3000);
      };

      try {
        const url =
          process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://spencer-apiv1.attabot.in';

        this.socket = io(url, { auth: { token } });
        this.attachCsvProgress(this.socket);

        this.socket.on('connect', () => {
          this.socketDownload.status = 'Counting orders...';
          this.socket.emit('join_room', { storeId, mobileNumber });
        });

        this.socket.on('connect_error', () => {
          finishWithError('Connection failed.');
        });

        this.socket.on('room_joined', async () => {
          try {
            await orderService.challanWiseOrderReport({ query });
            if (!this.socketDownload.showProgress) {
              this.socketDownload.status = 'Counting orders...';
            }
          } catch (err) {
            finishWithError(err?.response?.data?.message);
          }
        });

        this.socket.on('csv-chunk', data => {
          this.csvChunks.push(data.chunk);
        });

        this.socket.on('csv-complete', () => {
          this.socketDownload.percent = 100;
          this.socketDownload.status = 'Finalizing file...';

          const blob = new Blob(this.csvChunks, { type: 'text/csv' });
          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = `Challan_Wise_Report_${startdate}_to_${enddate}.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(objectUrl);

          this.socket.emit('leave_room', { storeId, mobileNumber });
          this.socket.disconnect();
          this.socket = null;

          setTimeout(() => {
            this.socketDownload.active = false;
          }, 1500);
        });

        this.socket.on('csv-error', () => {
          finishWithError('Error generating report.');
        });
      } catch (error) {
        this.socketDownload.active = false;
      }
    },

    async triggerReportAPI(startDate, endDate, mobileNumber, storeId) {
      try {
        const query = {
          startdate: startDate,
          enddate: endDate,
          storeId,
          mobileNumber
        };

        if (this.$route.query.db) {
          query.db = this.$route.query.db;
        }

        await this.getDetailReport({ query });
        this.socketDownload.status = 'Generating report';
      } catch (err) {
        console.error('API Error:', err);
      }
    },
    onFetchOffline() {
      this.isOnlineData = false;
      this.list({
        query: {
          ...this.$route.query
        }
      });
    },
    ifCallCenterExecutive() {
      const newUser = this.user.roles.map(role => role.name);
      const hasCallCenterRole = newUser.some(role => role.includes('CALL_CENTER_EXECUTIVE'));
      if (hasCallCenterRole) {
        return false;
      }
      return true;
    },
    isExecutiveAndNbl() {
      if (this.user.type === 1) {
        return false;
      }
      const newUser = this.user.roles.map(role => role.name);
      const hasCallCenterRole = newUser.some(role => role.includes('CALL_CENTER_EXECUTIVE'));
      if (hasCallCenterRole) {
        return false;
      }
      return true;
    },
    isLimitedAdmin() {
      // Regex pattern to match roles containing '_agency_admin'
      const agencyAdminRegex = /_agency_admin/i;
      return this.user?.roles?.some(r => agencyAdminRegex.test(r.name));
    },
    getAgencyKey() {
      // Regex pattern to match roles containing '_agency_admin'
      const agencyAdminRegex = /_agency_admin/i;
      const role = this.user?.roles?.map(r => r.name).find(n => agencyAdminRegex.test(n));
      if (!role) return '';
      // Strip trailing _AGENCY_ADMIN to get the agency token
      return role.replace(/_agency_admin$/i, '');
    },
    isSRLAdmin() {
      const newUser = this.user.roles.map(role => role.name);
      const isAdmin = newUser.some(role => role.includes('ADMIN') || role.includes('SUB_ADMIN_PD'));
      if (isAdmin && this.user.company === 'SRL') {
        return true;
      }
      return false;
    },
    isSRLAdminOrSsm() {
      const newUser = this.user.roles.map(role => role.name);
      const isAdminOrSsm = newUser.some(
        role => role.includes('ADMIN') || role.includes('SUB_ADMIN_PD') || role.includes('STORE_SALES_MANAGER')
      );
      if (isAdminOrSsm && this.user.company === 'SRL') {
        return true;
      }
      return false;
    },
    isSRLUser() {
      return this.user?.company === 'SRL';
    },
    ifAdmin() {
      const newUser = this.user.roles.map(role => role.name);
      const isAdmin = newUser.some(
        role => role.includes('ADMIN') || role.includes('SUB_ADMIN_PD') || role.includes('VOID_REPORT_ACCESS')
      );
      if (isAdmin) {
        return true;
      }
      return false;
    },
    limit(e) {
      return e.slice(0, 6);
    },
    async onAdd() {
      // More that one store
      this.$router.push(`/order/new/${null}`);
    },
    onEdit({ row }) {
      if (row.orderIncrementId !== undefined && row.orderIncrementId !== '') {
        router.push(`/orderFormBoxV2/${row.orderId}`);
      } else {
        router.push(`/order/${row.orderId}`);
      }
    },

    calculateAverageTime(timeArray) {
      const totalSeconds = timeArray.reduce((acc, time) => {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        return acc + hours * 3600 + minutes * 60 + seconds;
      }, 0);
      const averageSeconds = totalSeconds / timeArray.length;
      const hours = Math.floor(averageSeconds / 3600);
      const minutes = Math.floor((averageSeconds % 3600) / 60);
      const seconds = Math.floor(averageSeconds % 60);
      const timeReturn = t => {
        return String(t).padStart(2, '0');
      };
      return `${timeReturn(hours)}:${timeReturn(minutes)}:${timeReturn(seconds)}`;
    },
    totalAverageTimeConverter(totalSeconds, length) {
      const averageSeconds = totalSeconds / length;
      const seconds = Math.floor((averageSeconds / 1000) % 60);
      const minutes = Math.floor((averageSeconds / (1000 * 60)) % 60);
      const hours = Math.floor(averageSeconds / (1000 * 60 * 60));
      const timeReturn = t => {
        return String(t).padStart(2, '0');
      };
      return `${timeReturn(hours)}:${timeReturn(minutes)}:${timeReturn(seconds)}`;
    },
    milliSecondsToHours(totalSeconds) {
      if (totalSeconds < 0) {
        return '-';
      }
      const averageSeconds = totalSeconds;
      const seconds = Math.floor((averageSeconds / 1000) % 60);
      const minutes = Math.floor((averageSeconds / (1000 * 60)) % 60);
      const hours = Math.floor(averageSeconds / (1000 * 60 * 60));
      const timeReturn = t => {
        return String(t).padStart(2, '0');
      };
      return `${timeReturn(hours)}:${timeReturn(minutes)}:${timeReturn(seconds)}`;
    },
    async onShowUpload() {
      let footer =
        '<a href="https://spencer-template.s3.ap-south-1.amazonaws.com/Orders.csv" >Download sample upload file</a>';
      if (this.user.role === User.userRole.administrator) {
        footer =
          '<a href="https://spencer-template.s3.ap-south-1.amazonaws.com/OrdersAdmin.csv" >Download sample upload file</a>';
      }
      const { value: orderFile } = await Vue.swal({
        title: 'Upload file for orders..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your orders file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        showCancelButton: true,
        cancelButtonText: 'Close',
        footer,

        background: this.isDarkMode ? '#1e1e1e' : '#fff',
        color: this.isDarkMode ? '#fff' : '#000',
        customClass: {
          popup: this.isDarkMode ? 'swal-dark-mode' : ''
        }
      });
      if (orderFile) {
        const reader = new FileReader();
        reader.readAsText(orderFile);
        reader.onload = e => {
          this.upload({ data: e.target.result, router });
        };
      }
    },

    onExportCSV() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        this.download({ query: { ...this.$route.query, page_size: 5000, page: 1 } });
      } else {
        // No date filter applied: align export with list default (today's date range)
        const today = moment().format('YYYY-MM-DD');
        this.download({
          query: {
            ...this.$route.query,
            page_size: 5000,
            page: 1,
            startdate: today,
            enddate: today
          }
        });
      }
    },
    onExportProductCSV() {
      this.isProductReportExport = true;
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        this.download({ query: { ...this.$route.query, page_size: 5000, page: 1 } });
      } else {
        // No date filter applied: align export with list default (today's date range)
        const today = moment().format('YYYY-MM-DD');
        this.download({
          query: {
            ...this.$route.query,
            page_size: 5000,
            page: 1,
            startdate: today,
            enddate: today
          }
        });
      }
    },
    generateProductReportCSV(orders) {
      if (!orders || orders.length === 0) {
        Vue.swal({
          title: 'No Data Available',
          text: 'There are no orders to download.',
          icon: 'info',
          confirmButtonColor: '#3085d6'
        });
        return;
      }

      // CSV header with order columns first, then product columns, then posItems columns
      let csv =
        'Order Id,Order Date Id,Customer Name,Customer Address,Source,Customer Mobile,Created On,Updated On,Description,Store Id,Acknowledged,Delivered,Order Created Time,Order Acknowledged Time,Order Packaged Time,Bill Generated Time,Order Delivered Time,Order Mode,outboundType,Pincode,Bill Number,Bill Value,Order Create Lat,Order Create Long,Order Delivered Lat,Order Delivered Long,Product Name,Quantity,Article Code,MRP,Selling Price,Item Name,Item Code,Item Category,HSN Code,Item Quantity,UOM,Item MRP,Discount,Amount\n';

      orders.forEach(order => {
        // Check if order has posItemsArray (preserved from API) or posItems array (from POS orders)
        // Handle both posItemsArray and posItems fields
        let posItemsArray = null;
        if (order.posItemsArray && Array.isArray(order.posItemsArray) && order.posItemsArray.length > 0) {
          posItemsArray = order.posItemsArray;
        } else if (order.posItems) {
          // More lenient check - handle both array and other formats
          if (Array.isArray(order.posItems) && order.posItems.length > 0) {
            posItemsArray = order.posItems;
          } else if (typeof order.posItems === 'object' && order.posItems !== null) {
            // Handle case where posItems might be an object that needs to be converted
            const items = Object.values(order.posItems);
            if (Array.isArray(items) && items.length > 0) {
              posItemsArray = items;
            }
          }
        }

        // Store product rows temporarily to match with POS items
        const productRows = [];

        // Helper function to remove leading zeros from article code
        const removeLeadingZeros = code => {
          if (!code) return '';
          const str = String(code).trim();
          // Remove leading zeros but keep at least one digit if all are zeros
          return str.replace(/^0+/, '') || '0';
        };
        // Process products first
        // Handle both string and array formats for products
        const productsString = Array.isArray(order.products) ? '' : order.products || '';
        let hasProducts = false;

        if (productsString && typeof productsString === 'string' && productsString.trim()) {
          // Split products - handle both underscore and comma as product separators
          // Some products use ':::' as field separator, others use ',' as field separator
          const productStrings = [];

          // First, split by underscore to get product groups
          const partsByUnderscore = productsString
            .split('_')
            .map(part => part.trim())
            .filter(part => part !== '');

          partsByUnderscore.forEach(part => {
            if (part.includes(':::')) {
              // This part uses ::: separator - split by ::: to get individual products
              // But also check for commas that might separate multiple ::: products
              const commaSplit = part.split(',');
              commaSplit.forEach(cp => {
                if (cp.trim().includes(':::')) {
                  productStrings.push(cp.trim());
                }
              });
            } else {
              // This part uses comma separator - need to intelligently split
              // Pattern: ProductName,Quantity,ArticleCode,MRP,SellingPrice,NextProductName,...
              const commaParts = part
                .split(',')
                .map(p => p.trim())
                .filter(p => p !== '');

              // Group into products: each product has 5 fields (name + 4 numeric fields)
              for (let i = 0; i < commaParts.length; i += 5) {
                const productFields = commaParts.slice(i, i + 5);
                if (productFields.length > 0 && productFields[0]) {
                  // Only add if we have at least a product name
                  productStrings.push(productFields.join(','));
                }
              }
            }
          });

          // Process each product string
          productStrings.forEach(productString => {
            // Skip if empty
            if (!productString) {
              return;
            }

            let allFields = [];

            // Detect field separator - check if product uses ::: or comma
            if (productString.includes(':::')) {
              // Standard format: split by :::
              allFields = productString
                .split(':::')
                .slice(0, 5)
                .map(field => field.trim());
            } else {
              // Comma-separated format: split by comma
              allFields = productString
                .split(',')
                .slice(0, 5)
                .map(field => field.trim());
            }

            // Extract exactly 5 fields - verify each field exists
            // Expected fields: Product Name, Quantity, Article Code, MRP, Selling Price
            // If a field is missing or empty, use "0" for missing fields
            const productName = allFields[0] || '';
            const quantity = allFields[1] || '0';
            const articleCode = allFields[2] || '0';
            const mrp = allFields[3] || '0';
            const sellingPrice = allFields[4] || '0';

            // Only create a row if we have at least a product name
            if (productName) {
              hasProducts = true;
              // Store product row with its article code for matching
              const normalizedArticleCode = removeLeadingZeros(articleCode);
              productRows.push({
                productName,
                quantity,
                articleCode,
                normalizedArticleCode,
                mrp,
                sellingPrice,
                posItems: [] // Will store matching POS items here
              });
            }
          });
        }

        // Process posItems array - match with products or create new rows
        if (posItemsArray) {
          posItemsArray.forEach(posItem => {
            // Get itemCode from posItem and remove leading zeros
            const posItemCode = posItem?.itemCode || '';
            const normalizedPosItemCode = removeLeadingZeros(posItemCode);

            // Try to find matching product by comparing normalized article codes
            let matched = false;
            if (normalizedPosItemCode) {
              for (let i = 0; i < productRows.length; i += 1) {
                if (productRows[i].normalizedArticleCode === normalizedPosItemCode) {
                  // Match found - append POS item to this product row
                  productRows[i].posItems.push(posItem);
                  matched = true;
                  break;
                }
              }
            }

            // If no match found, create a new row with empty product columns
            if (!matched) {
              productRows.push({
                productName: '',
                quantity: '',
                articleCode: '',
                normalizedArticleCode: '',
                mrp: '',
                sellingPrice: '',
                posItems: [posItem]
              });
            }
          });
        }

        // Now generate CSV rows from productRows
        if (productRows.length > 0) {
          productRows.forEach(productRow => {
            if (productRow.posItems.length > 0) {
              // If there are POS items, create one row per POS item
              productRow.posItems.forEach(posItem => {
                const orderRow = this.buildOrderRow(
                  order,
                  productRow.productName,
                  productRow.quantity,
                  productRow.articleCode,
                  productRow.mrp,
                  productRow.sellingPrice,
                  posItem
                );
                csv += `${orderRow}\n`;
              });
            } else {
              // No POS items, just create a row with product data
              const orderRow = this.buildOrderRow(
                order,
                productRow.productName,
                productRow.quantity,
                productRow.articleCode,
                productRow.mrp,
                productRow.sellingPrice,
                null
              );
              csv += `${orderRow}\n`;
            }
          });
        } else if (!hasProducts && !posItemsArray) {
          // If no products and no posItems, still create a row with empty fields
          const orderRow = this.buildOrderRow(order, '', '', '', '', '', null);
          csv += `${orderRow}\n`;
        }
      });

      // Download the CSV file
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'Product-Report.csv';
      anchor.click();
    },
    buildOrderRow(order, productName, quantity, articleCode, mrp, sellingPrice, posItem) {
      // Escape CSV values
      const escapeCSV = val => {
        if (val === null || val === undefined) return '';
        const str = String(val);
        return `"${str.replace(/"/g, '""')}"`;
      };

      // Use the shared formatDateForCSV method to ensure consistency
      const formatDate = dateValue => {
        return this.formatDateForCSV(dateValue);
      };

      // Calculate bill value from posItems array if available
      let billValue = 0;
      const posItemsArray =
        order.posItemsArray || (order.posItems && Array.isArray(order.posItems) ? order.posItems : null);
      if (posItemsArray && Array.isArray(posItemsArray) && posItemsArray.length > 0) {
        billValue = posItemsArray.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
      } else if (order.posItems && typeof order.posItems === 'number') {
        billValue = order.posItems;
      }

      // Build array of all values first, then join with commas
      const values = [
        // Order columns first
        escapeCSV(order.orderId),
        escapeCSV(order.orderDateId != null && order.orderDateId !== '' ? `\t${order.orderDateId}` : ''),
        escapeCSV(order.name),
        escapeCSV(order.address),
        escapeCSV(order.source),
        escapeCSV(order.customerMobile),
        escapeCSV(formatDate(order.dateCreated)),
        escapeCSV(formatDate(order.dateUpdated)),
        escapeCSV(order.description),
        escapeCSV(order.storeid),
        escapeCSV(order.isAcknowledged),
        escapeCSV(order.isDelivered),
        escapeCSV(formatDate(order.createdAt)),
        escapeCSV(formatDate(order.acknowledgedTime)),
        escapeCSV(formatDate(order.packagedTime)),
        escapeCSV(formatDate(order.posPingTime)),
        escapeCSV(formatDate(order.actualDeliveredTime)),
        escapeCSV(order.orderMode),
        escapeCSV(order.outboundType),
        escapeCSV(order.pinCode),
        escapeCSV(order.billNumber),
        escapeCSV(billValue.toFixed(2)),
        // Location columns
        escapeCSV(order.orderCreateLocation?.lat || ''),
        escapeCSV(order.orderCreateLocation?.long || ''),
        escapeCSV(order.orderDeliveredLocation?.lat || ''),
        escapeCSV(order.orderDeliveredLocation?.long || ''),
        // Then product columns
        escapeCSV(productName),
        escapeCSV(quantity),
        escapeCSV(articleCode),
        escapeCSV(mrp),
        escapeCSV(sellingPrice),
        // Then posItems columns
        escapeCSV(posItem?.itemName || ''),
        escapeCSV(posItem?.itemCode || ''),
        escapeCSV(posItem?.itemCategory || ''),
        escapeCSV(posItem?.hsnCode || ''),
        escapeCSV(posItem?.quantity || ''),
        escapeCSV(posItem?.UOM || ''),
        escapeCSV(posItem?.mrp || ''),
        escapeCSV(posItem?.disc || ''),
        escapeCSV(posItem?.amount || '')
      ];

      // Join with commas - no trailing comma
      return values.join(',');
    },
    downloadCurrentListData() {
      // For limited admin, download the current data available in the list
      if (this.orders.length === 0) {
        Vue.swal({
          title: 'No Data Available',
          text: 'There are no orders in the current list to download.',
          icon: 'info',
          confirmButtonColor: '#3085d6'
        });
        return;
      }

      // Create CSV from current orders data
      let csv;
      if (this.user.company === 'SRL') {
        csv =
          'Order Id,Order Date Id,Customer Name,Customer Address,Source,Customer Mobile,Created On,Updated On,Description,Store Id,Acknowledged,Delivered,Products,Order Created Time,order Acknowledged Time,Order Packaged Time ,Bill Generated Time,Order Delivered Time,Order Mode,outboundType, Pincode,Bill Number,Bill Value,Delivery Acknowledged,Delivery Acknowledged Time,Delivery Acknowledged By,On Role,Picker Employee Id,Picker Mobile Number,Picker Name,Picker Agency ,Bill No found Status,Sales Report Status\n';
        this.orders.forEach(row => {
          csv += `"${row.orderId}","\t${row.orderDateId || ''}","${row.name
            ?.replaceAll(',', '_')
            .replaceAll('"', '_')}","${row.address?.replaceAll(',', '_').replaceAll('"', '_')}","${row.source}","${
            row.customerMobile
          }","${this.formatDateForCSV(row.dateCreated)}","${this.formatDateForCSV(
            row.dateUpdated
          )}","${row.description?.replaceAll(',', '_').replaceAll('"', '_')}","${row.storeid}","${
            row.isAcknowledged
          }","${row.isDelivered}","${row.products?.replaceAll(',', '_').replaceAll('"', '_')}","${this.formatDateForCSV(
            row.createdAt
          )}","${this.formatDateForCSV(row.acknowledgedTime)}","${this.formatDateForCSV(
            row.packagedTime
          )}","${this.formatDateForCSV(row.posPingTime)}","${this.formatDateForCSV(row.actualDeliveredTime)}","${
            row.orderMode
          }","${row.outboundType || ''}","${row.pinCode}","${row.billNumber}","${Number(row.posItems || 0).toFixed(
            2
          )}","${row.isDeliveryAcknowledged}","${this.formatDateForCSV(row.deliveryAcknowledgedTime)}","${
            row.deliveryAcknowledgedBy
          }","${row.ifOffRole}","${row.employeeCode}","${row.employeeMobile}","${row.employeeName}","${
            row.employeeCompany
          }","${row.finalStatus}","${row.matchedWithSales}"\n`;
        });
      } else {
        csv =
          'Order Id,Order Date Id,Customer Name,Customer Address,Source,Customer Mobile,Created On,Updated On,Description,Store Id,Acknowledged,Delivered,Products,Order Created Time,order Acknowledged Time,Order Packaged Time ,Bill Generated Time,Order Delivered Time,Order Mode,outboundType, Pincode,Bill Number,Bill Value\n';
        this.orders.forEach(row => {
          csv += `"${row.orderId}","\t${row.orderDateId || ''}","${row.name}","${row.address}","${row.source}","${
            row.customerMobile
          }","${this.formatDateForCSV(row.dateCreated)}","${this.formatDateForCSV(row.dateUpdated)}","${
            row.description
          }","${row.storeid}","${row.isAcknowledged}","${row.isDelivered}","${row.products}","${this.formatDateForCSV(
            row.createdAt
          )}","${this.formatDateForCSV(row.acknowledgedTime)}","${this.formatDateForCSV(
            row.packagedTime
          )}","${this.formatDateForCSV(row.posPingTime)}","${this.formatDateForCSV(row.actualDeliveredTime)}","${
            row.orderMode
          }","${row.outboundType || ''}","${row.pinCode}","${row.billNumber}","${Number(row.posItems || 0).toFixed(
            2
          )}"\n`;
        });
      }

      // Download the CSV file
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'Orders.csv';
      anchor.click();
    },
    onRiderAgency() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        this.download({ query: { ...this.$route.query, page_size: 5000, page: 1 }, isRider: true });
      } else {
        this.download({
          query: {
            ...this.$route.query,
            page_size: 5000,
            page: 1,
            startdate: moment().subtract(1, 'months').format('MMM YYYY')
          },
          isRider: true
        });
      }
    },
    onRiderReport() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        this.riderReport({ query: { ...this.$route.query, page_size: 5000, page: 1 } });
      } else {
        this.riderReport({
          query: {
            ...this.$route.query,
            startdate: moment().format('MMM YYYY')
          }
        });
      }
    },
    async onChallanPaymentReport() {
      const startdate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const enddate = this.$route.query.enddate || moment().format('YYYY-MM-DD');
      this.socketDownload = {
        active: true,
        status: 'Generating challan payment report...',
        showProgress: false
      };

      const csvCell = value => `"${String(value ?? '').replace(/"/g, '""')}"`;

      try {
        const response = await orderService.challanPaymentReport({
          query: { startdate, enddate }
        });
        const payload = response?.data;
        let rows = [];
        if (Array.isArray(payload?.rows)) {
          rows = payload.rows;
        } else if (Array.isArray(payload)) {
          rows = payload;
        }

        let csv =
          'Store Code,Challan DATE,Customer Mobile,Till Number,Challan Number,Final Challan Amount,Transaction ID (Juspay),Mode of Payment,Rider Name,Rider Mobile,Transaction Status\n';

        rows.forEach(row => {
          csv += `${[
            csvCell(row.storeCode),
            csvCell(row.challanDate ? moment(row.challanDate).format('DD-MM-YYYY') : ''),
            csvCell(row.customerMobile),
            csvCell(row.tillNumber),
            csvCell(row.challanNumber),
            csvCell(row.finalChallanAmount),
            csvCell(row.transactionId),
            csvCell(row.modeOfPayment),
            csvCell(row.riderName),
            csvCell(row.riderMobile),
            csvCell(row.transactionStatus)
          ].join(',')}\n`;
        });

        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = `Challan_Payment_Report_${startdate}_to_${enddate}.csv`;
        anchor.click();

        this.socketDownload.status = 'Download ready';
        setTimeout(() => {
          this.socketDownload.active = false;
        }, 800);
      } catch (error) {
        this.socketDownload.status = 'Error generating report.';
        setTimeout(() => {
          this.socketDownload.active = false;
        }, 2500);
      }
    },
    onRiderChallanArticleReport() {
      const startdate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const enddate = this.$route.query.enddate || moment().format('YYYY-MM-DD');
      this.socketDownload = {
        active: true,
        status: 'Connecting to server...',
        showProgress: false,
        percent: 0,
        processed: 0,
        total: 0
      };
      this.csvChunks = [];

      const token = localStorage.getItem('token');
      const storeId = String(new Date().getTime());
      const mobileNumber = this.authUser?.mobile || '9999999999';

      try {
        const url =
          process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://spencer-apiv1.attabot.in';

        this.socket = io(url, { auth: { token } });

        this.socket.on('connect', () => {
          this.socketDownload.status = 'Generating report data...';
          this.socket.emit('join_room', { storeId, mobileNumber });
        });

        this.socket.on('room_joined', async () => {
          try {
            await orderService.riderChallanArticleReport({
              query: { startdate, enddate, storeId, mobileNumber }
            });
            this.socketDownload.status = 'Generating report';
          } catch (err) {
            this.socketDownload.status = 'Error generating report.';
            this.socket.emit('leave_room', { storeId, mobileNumber });
            this.socket.disconnect();
            setTimeout(() => {
              this.socketDownload.active = false;
            }, 3000);
          }
        });

        this.socket.on('csv-chunk', data => {
          this.csvChunks.push(data.chunk);
          this.socketDownload.status = 'Receiving data chunks...';
        });

        this.socket.on('csv-complete', () => {
          this.socketDownload.status = 'Finalizing file...';

          const blob = new Blob(this.csvChunks, { type: 'text/csv' });
          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = `Rider_Challan_Article_Report_${startdate}_to_${enddate}.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(objectUrl);

          this.socket.emit('leave_room', { storeId, mobileNumber });
          this.socket.disconnect();

          setTimeout(() => {
            this.socketDownload.active = false;
          }, 1500);
        });

        this.socket.on('csv-error', () => {
          this.socketDownload.status = 'Error generating report.';
          setTimeout(() => {
            this.socketDownload.active = false;
          }, 3000);
        });
      } catch (error) {
        this.socketDownload.active = false;
      }
    },
    onExportMessageCSV() {
      this.downloadMessageRecord({ query: {} });
    },

    onAptReport() {
      const currentDate = new Date().setHours(0, 0, 0, 0);
      const selectedStartDate = new Date(this.$route.query.startdate).setHours(0, 0, 0, 0);
      const selectedEndDate = new Date(this.$route.query.enddate).setHours(0, 0, 0, 0);

      if (selectedStartDate === currentDate || selectedEndDate === currentDate) {
        Vue.swal({
          title: 'Wrong Date Selected',
          text: 'Please select date other than today.',
          icon: 'error',
          confirmButtonColor: '#3085d6'
        });
        return;
      }

      this.downloadAptReport({
        query: {
          startdate: this.$route.query.startdate,
          enddate: this.$route.query.enddate
        }
      });
    },
    onDelete({ row }) {
      if (!this.user.storeids.includes(row.storeid)) {
        Vue.swal({
          title: 'Sorry, you can not delete an order of other store..',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Okay'
        });
      } else {
        Vue.swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this.",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',

          preConfirm: () => {
            this.deleteOne({
              id: row.orderId,
              sort: true
            });
          }
        });
      }
    },
    onAcknowledge({ row }) {
      if (row.isAcknowledged) {
        Vue.swal({
          title: 'Are you sure?',
          text: 'The user has been already acknowledged. Do you want to send messgae again ?',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Send message again!',

          preConfirm: () => {
            this.sendAcknowledgement({
              id: row.orderId,
              mobile: row.customerMobile,
              type: 'ORDER_ACKNOWLEDGEMENT',
              query: this.$route.query,
              router
            });
          }
        });
      } else {
        Vue.swal({
          title: 'Are you sure?',
          text: 'Do you want to do send acknowledge sms for this order ?',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm',

          preConfirm: () => {
            this.sendAcknowledgement({
              id: row.orderId,
              mobile: row.customerMobile,
              type: 'ORDER_ACKNOWLEDGEMENT',
              query: this.$route.query,
              router
            });
          }
        });
      }
    },

    // Helper method to generate regular agency report
    generateRegularAgencyReport(filteredValues) {
      // 2a. Group by agency
      const agencyGrouped = {};
      filteredValues.forEach(order => {
        const agency = order.employeeCompany || '-';
        const rider = order.employeeName || '-';

        if (!agencyGrouped[agency]) {
          agencyGrouped[agency] = { totalBill: 0, count: 0, riders: new Set() };
        }
        agencyGrouped[agency].totalBill += Number(order.posItems || 0);
        agencyGrouped[agency].count += 1;
        agencyGrouped[agency].riders.add(rider);
      });

      // 2b. Group by rider
      const riderGrouped = {};
      filteredValues.forEach(order => {
        const rider = order.employeeName || '-';
        const agency = order.employeeCompany || '-';
        const riderKey = `${rider}||${agency}`;
        const storeId = order.storeid || 'Not Associated';

        if (!riderGrouped[riderKey]) {
          riderGrouped[riderKey] = { totalBill: 0, count: 0, isDelivered: 0, storeId };
        }
        riderGrouped[riderKey].totalBill += Number(order.posItems || 0);
        riderGrouped[riderKey].count += 1;
        const deliveredFlag =
          order.isDelivered === true ||
          order.isDelivered === 'True' ||
          order.isDelivered === 1 ||
          order.isDelivered === '1';
        if (deliveredFlag) {
          riderGrouped[riderKey].isDelivered += 1;
        }
      });

      // 3. Create CSV
      let csv = '';
      csv += `,,Date: ${this.$route.query.startdate} to ${this.$route.query.enddate}\n`;
      csv += 'Agency Wise Order Report\n';
      csv += 'Rider Agency,Total Bill Value,Number of Orders,Number of Riders\n';

      let totalAgencyBill = 0;
      let totalAgencyOrders = 0;
      let totalAgencyRiders = 0;

      Object.entries(agencyGrouped).forEach(([agency, data]) => {
        csv += `"${agency}","${data.totalBill.toFixed(2)}","${data.count}","${data.riders.size}"\n`;
        totalAgencyBill += data.totalBill;
        totalAgencyOrders += data.count;
        totalAgencyRiders += data.riders.size;
      });

      // Add agency totals row
      csv += `"TOTAL","${totalAgencyBill.toFixed(2)}","${totalAgencyOrders}","${totalAgencyRiders}"\n`;

      // Rider Wise Order Report
      csv += '\nRider Wise Order Report\n';
      csv += 'Store Id,Rider Name,Rider Agency,Total Bill Value,Number of Orders,Acknowledge count,Delivery count\n';

      let totalRiderBill = 0;
      let totalRiderOrders = 0;
      let totalRiderDelivered = 0;
      Object.entries(riderGrouped).forEach(([riderKey, data]) => {
        const [rider, agency] = riderKey.split('||');
        csv += `"${data.storeId}","${rider}","${agency}","${data.totalBill.toFixed(2)}","${data.count}","${
          data.count
        }","${data.isDelivered}"\n`;
        totalRiderBill += data.totalBill;
        totalRiderOrders += data.count;
        totalRiderDelivered += data.isDelivered;
      });

      // Add rider totals row
      csv += `"TOTAL","","","${totalRiderBill.toFixed(
        2
      )}","${totalRiderOrders}","${totalRiderOrders}","${totalRiderDelivered}"\n`;

      return csv;
    },

    // Helper method to generate regular rider report
    generateRegularRiderReport(newValue) {
      let csv = ',,,,Riders Report\n\n';
      csv += 'Store,Acknowledged By,Acknowledge Count,Delivery Count\n';
      newValue.forEach(row => {
        csv += `"${row.store}","${row.deliveryAcknowledgedBy}","${row.orderCount}","${row.totalOrderDelivered}"\n`;
      });
      return csv;
    },

    // Helper method to generate date-wise agency report for limited admin
    async generateDateWiseAgencyReport() {
      // Use today's date as default if no date range is selected
      const startDate = this.$route.query.startdate ? moment(this.$route.query.startdate) : moment();
      const endDate = this.$route.query.enddate ? moment(this.$route.query.enddate) : moment();
      let csv = '';

      // Generate date range
      const dates = [];
      const currentDate = startDate.clone();
      while (currentDate.isSameOrBefore(endDate)) {
        dates.push(currentDate.format('YYYY-MM-DD'));
        currentDate.add(1, 'day');
      }

      // Fetch data for each date using Promise.all to avoid await in loop
      const datePromises = dates.map(async date => {
        try {
          const response = await orderService.list({
            query: {
              ...this.$route.query,
              startdate: date,
              enddate: date,
              page_size: 5000,
              page: 1
            }
          });

          const dayData = response.data.rows;
          const filteredValues = dayData.filter(order => {
            const hasBillNumber = !!order.billNumber;
            const storeId = (order.storeid || '').toUpperCase();
            const isStoreIdInvalid = storeId.startsWith('N') || ['D413', 'S117'].includes(storeId);
            return hasBillNumber && !isStoreIdInvalid;
          });

          return { date, filteredValues };
        } catch (error) {
          console.error(`Error fetching data for date ${date}:`, error);
          return { date, filteredValues: [] };
        }
      });

      const dateResults = await Promise.all(datePromises);

      // Only generate summary section if there are multiple dates
      if (dates.length > 1) {
        csv += this.generateAgencySummarySection(dateResults);
      }

      // Generate individual date sections
      dateResults.forEach(({ date, filteredValues }) => {
        if (filteredValues.length > 0) {
          csv += this.generateDateSectionAgencyReport(date, filteredValues);
        }
      });

      return csv;
    },

    // Helper method to generate summary section for agency report
    generateAgencySummarySection(dateResults) {
      let csv = '';

      // Combine all filtered values from all dates
      const allFilteredValues = dateResults.reduce((acc, { filteredValues }) => {
        return acc.concat(filteredValues);
      }, []);

      if (allFilteredValues.length === 0) {
        return csv;
      }

      // Add summary header
      csv += '=== SUMMARY FOR ALL DATES ===\n';
      const startDate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const endDate = this.$route.query.enddate || moment().format('YYYY-MM-DD');
      csv += `Date Range: ${startDate} to ${endDate}\n\n`;

      // Agency Wise Summary
      csv += 'Agency Wise Order Report - SUMMARY\n';
      csv += 'Rider Agency,Total Bill Value,Number of Orders,Number of Riders,Delivery Count\n';

      // Group by agency for all dates combined
      const agencyGrouped = {};
      allFilteredValues.forEach(order => {
        const agency = order.employeeCompany || '-';
        const rider = order.employeeName || '-';

        if (!agencyGrouped[agency]) {
          agencyGrouped[agency] = { totalBill: 0, count: 0, riders: new Set(), delivered: 0 };
        }
        agencyGrouped[agency].totalBill += Number(
          order.posItems?.map(item => item.amount).reduce((a, b) => a + b, 0) || 0
        );
        agencyGrouped[agency].count += 1;
        agencyGrouped[agency].riders.add(rider);

        const deliveredFlag =
          order.isDelivered === true ||
          order.isDelivered === 'True' ||
          order.isDelivered === 1 ||
          order.isDelivered === '1';
        if (deliveredFlag) {
          agencyGrouped[agency].delivered += 1;
        }
      });

      let totalAgencyBill = 0;
      let totalAgencyOrders = 0;
      let totalAgencyRiders = 0;
      let totalAgencyDelivered = 0;

      Object.entries(agencyGrouped).forEach(([agency, data]) => {
        csv += `"${agency}","${data.totalBill.toFixed(2)}","${data.count}","${data.riders.size}","${data.delivered}"\n`;
        totalAgencyBill += data.totalBill;
        totalAgencyOrders += data.count;
        totalAgencyRiders += data.riders.size;
        totalAgencyDelivered += data.delivered;
      });

      csv += `"TOTAL","${totalAgencyBill.toFixed(
        2
      )}","${totalAgencyOrders}","${totalAgencyRiders}","${totalAgencyDelivered}"\n`;

      // Rider Wise Summary
      csv += '\nRider Wise Order Report - SUMMARY\n';
      csv += 'Store Id,Rider Name,Rider Agency,Total Bill Value,Number of Orders,Acknowledge count,Delivery count\n';

      const riderGrouped = {};
      allFilteredValues.forEach(order => {
        const rider = order.employeeName || '-';
        const agency = order.employeeCompany || '-';
        const riderKey = `${rider}||${agency}`;
        const storeId = order.storeid || 'Not Associated';

        if (!riderGrouped[riderKey]) {
          riderGrouped[riderKey] = { totalBill: 0, count: 0, isDelivered: 0, storeId };
        }
        riderGrouped[riderKey].totalBill += Number(
          order.posItems?.map(item => item.amount).reduce((a, b) => a + b, 0) || 0
        );
        riderGrouped[riderKey].count += 1;
        const deliveredFlag =
          order.isDelivered === true ||
          order.isDelivered === 'True' ||
          order.isDelivered === 1 ||
          order.isDelivered === '1';
        if (deliveredFlag) {
          riderGrouped[riderKey].isDelivered += 1;
        }
      });

      let totalRiderBill = 0;
      let totalRiderOrders = 0;
      let totalRiderDelivered = 0;
      Object.entries(riderGrouped).forEach(([riderKey, data]) => {
        const [rider, agency] = riderKey.split('||');
        csv += `"${data.storeId}","${rider}","${agency}","${data.totalBill.toFixed(2)}","${data.count}","${
          data.count
        }","${data.isDelivered}"\n`;
        totalRiderBill += data.totalBill;
        totalRiderOrders += data.count;
        totalRiderDelivered += data.isDelivered;
      });

      csv += `"TOTAL","","","${totalRiderBill.toFixed(
        2
      )}","${totalRiderOrders}","${totalRiderOrders}","${totalRiderDelivered}"\n`;

      csv += '\n=== DATE-WISE BREAKDOWN ===\n\n';

      return csv;
    },

    // Helper method to generate a single date section for agency report
    generateDateSectionAgencyReport(date, filteredValues) {
      let csv = '';

      // Add date header
      csv += `\n\n=== DATE: ${date} ===\n`;
      csv += 'Agency Wise Order Report\n';
      csv += 'Rider Agency,Total Bill Value,Number of Orders,Number of Riders,Delivery Count\n';

      // Group by agency for this date
      const agencyGrouped = {};
      filteredValues.forEach(order => {
        const agency = order.employeeCompany || '-';
        const rider = order.employeeName || '-';

        if (!agencyGrouped[agency]) {
          agencyGrouped[agency] = { totalBill: 0, count: 0, riders: new Set(), delivered: 0 };
        }
        agencyGrouped[agency].totalBill += Number(
          order.posItems?.map(item => item.amount).reduce((a, b) => a + b, 0) || 0
        );
        agencyGrouped[agency].count += 1;
        agencyGrouped[agency].riders.add(rider);

        const deliveredFlag =
          order.isDelivered === true ||
          order.isDelivered === 'True' ||
          order.isDelivered === 1 ||
          order.isDelivered === '1';
        if (deliveredFlag) {
          agencyGrouped[agency].delivered += 1;
        }
      });

      let totalAgencyBill = 0;
      let totalAgencyOrders = 0;
      let totalAgencyRiders = 0;
      let totalAgencyDelivered = 0;

      Object.entries(agencyGrouped).forEach(([agency, data]) => {
        csv += `"${agency}","${data.totalBill.toFixed(2)}","${data.count}","${data.riders.size}","${data.delivered}"\n`;
        totalAgencyBill += data.totalBill;
        totalAgencyOrders += data.count;
        totalAgencyRiders += data.riders.size;
        totalAgencyDelivered += data.delivered;
      });

      csv += `"TOTAL","${totalAgencyBill.toFixed(
        2
      )}","${totalAgencyOrders}","${totalAgencyRiders}","${totalAgencyDelivered}"\n`;

      // Rider Wise Order Report for this date
      csv += '\nRider Wise Order Report\n';
      csv += 'Store Id,Rider Name,Rider Agency,Total Bill Value,Number of Orders,Acknowledge count,Delivery count\n';

      const riderGrouped = {};
      filteredValues.forEach(order => {
        const rider = order.employeeName || '-';
        const agency = order.employeeCompany || '-';
        const riderKey = `${rider}||${agency}`;
        const storeId = order.storeid || 'Not Associated';

        if (!riderGrouped[riderKey]) {
          riderGrouped[riderKey] = { totalBill: 0, count: 0, isDelivered: 0, storeId };
        }
        riderGrouped[riderKey].totalBill += Number(
          order.posItems?.map(item => item.amount).reduce((a, b) => a + b, 0) || 0
        );
        riderGrouped[riderKey].count += 1;
        const deliveredFlag =
          order.isDelivered === true ||
          order.isDelivered === 'True' ||
          order.isDelivered === 1 ||
          order.isDelivered === '1';
        if (deliveredFlag) {
          riderGrouped[riderKey].isDelivered += 1;
        }
      });

      let totalRiderBill = 0;
      let totalRiderOrders = 0;
      let totalRiderDelivered = 0;
      Object.entries(riderGrouped).forEach(([riderKey, data]) => {
        const [rider, agency] = riderKey.split('||');
        csv += `"${data.storeId}","${rider}","${agency}","${data.totalBill.toFixed(2)}","${data.count}","${
          data.count
        }","${data.isDelivered}"\n`;
        totalRiderBill += data.totalBill;
        totalRiderOrders += data.count;
        totalRiderDelivered += data.isDelivered;
      });

      csv += `"TOTAL","","","${totalRiderBill.toFixed(
        2
      )}","${totalRiderOrders}","${totalRiderOrders}","${totalRiderDelivered}"\n`;

      return csv;
    },

    // Helper method to generate date-wise rider report for limited admin
    async generateDateWiseRiderReport() {
      // Use today's date as default if no date range is selected
      const startDate = this.$route.query.startdate ? moment(this.$route.query.startdate) : moment();
      const endDate = this.$route.query.enddate ? moment(this.$route.query.enddate) : moment();
      let csv = '';

      // Generate date range
      const dates = [];
      const currentDate = startDate.clone();
      while (currentDate.isSameOrBefore(endDate)) {
        dates.push(currentDate.format('YYYY-MM-DD'));
        currentDate.add(1, 'day');
      }

      // Fetch data for each date using Promise.all to avoid await in loop
      const datePromises = dates.map(async date => {
        try {
          const response = await orderService.riderReport({
            query: {
              ...this.$route.query,
              startdate: date,
              enddate: date
            }
          });

          const dayData = response.data;

          return { date, dayData };
        } catch (error) {
          console.error(`Error fetching rider data for date ${date}:`, error);
          return { date, dayData: [] };
        }
      });

      const dateResults = await Promise.all(datePromises);

      // Only generate summary section if there are multiple dates
      if (dates.length > 1) {
        csv += this.generateRiderSummarySection(dateResults);
      }

      // Generate individual date sections
      dateResults.forEach(({ date, dayData }) => {
        if (dayData.length > 0) {
          csv += this.generateDateSectionRiderReport(date, dayData);
        }
      });

      return csv;
    },

    // Helper method to generate summary section for rider report
    generateRiderSummarySection(dateResults) {
      let csv = '';

      // Combine all day data from all dates
      const allDayData = dateResults.reduce((acc, { dayData }) => {
        return acc.concat(dayData);
      }, []);

      if (allDayData.length === 0) {
        return csv;
      }

      // Add summary header
      csv += '=== SUMMARY FOR ALL DATES ===\n';
      const startDate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const endDate = this.$route.query.enddate || moment().format('YYYY-MM-DD');
      csv += `Date Range: ${startDate} to ${endDate}\n\n`;

      // Rider Report Summary
      csv += 'Riders Report - SUMMARY\n';
      csv += 'Store,Acknowledged By,Acknowledge Count,Delivery Count\n';

      // Group by store and rider for all dates combined
      const riderGrouped = {};
      allDayData.forEach(row => {
        const key = `${row.store}||${row.deliveryAcknowledgedBy}`;

        if (!riderGrouped[key]) {
          riderGrouped[key] = {
            store: row.store,
            deliveryAcknowledgedBy: row.deliveryAcknowledgedBy,
            orderCount: 0,
            totalOrderDelivered: 0
          };
        }

        riderGrouped[key].orderCount += row.orderCount;
        riderGrouped[key].totalOrderDelivered += row.totalOrderDelivered;
      });

      let totalAcknowledgeCount = 0;
      let totalDeliveryCount = 0;

      Object.values(riderGrouped).forEach(row => {
        csv += `"${row.store}","${row.deliveryAcknowledgedBy}","${row.orderCount}","${row.totalOrderDelivered}"\n`;
        totalAcknowledgeCount += row.orderCount;
        totalDeliveryCount += row.totalOrderDelivered;
      });

      csv += `"TOTAL","","${totalAcknowledgeCount}","${totalDeliveryCount}"\n`;

      csv += '\n=== DATE-WISE BREAKDOWN ===\n\n';

      return csv;
    },

    // Helper method to generate a single date section for rider report
    generateDateSectionRiderReport(date, dayData) {
      let csv = '';

      // Add date header
      csv += `\n\n=== DATE: ${date} ===\n`;
      csv += 'Riders Report\n';
      csv += 'Store,Acknowledged By,Acknowledge Count,Delivery Count\n';

      dayData.forEach(row => {
        csv += `"${row.store}","${row.deliveryAcknowledgedBy}","${row.orderCount}","${row.totalOrderDelivered}"\n`;
      });

      return csv;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.download-progress-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  padding: 24px;
}

.progress-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  padding: 28px 28px 24px;
  border-radius: 20px;
  text-align: left;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
}

.progress-kicker {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.progress-card .status-title {
  color: #0f172a !important;
  margin: 6px 0 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.progress-percent {
  margin-top: 18px;
  color: #0f172a;
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.04em;
}

.progress-percent span {
  margin-left: 2px;
  color: #64748b;
  font-size: 18px;
  font-weight: 600;
}

.loader-spinner {
  display: block;
  width: 36px;
  height: 36px;
  border: 3px solid #e2e8f0;
  border-radius: 50%;
  border-top-color: #2563eb;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.sub-text,
.progress-count {
  margin: 14px 0 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.4;
}

.progress-count {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}

.progress-count span {
  margin: 0 4px;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
}

.progress-track {
  width: 100%;
  height: 8px;
  margin-top: 14px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #2563eb, #7c3aed);
  transition: width 0.35s ease;
}
</style>
